import { isPhone } from '@ott/utility-form-validate-rules';

export function getName(data, forceFullName) {
  const { firstName, lastName, name, email } = data;

  if (firstName || lastName) {
    if (firstName && lastName && forceFullName) {
      return `${firstName} ${lastName}`;
    }

    if (firstName) {
      return firstName;
    }

    return lastName;
  }

  if (name) {
    return name;
  }

  if (email) {
    return email.split('@')[0];
  }

  return null;
}

export function isUserPremium(status) {
  return status === 'premium';
}

export function isUserAuthenticated(auth) {
  return Boolean(auth?.data?.auth);
}

export function isUserHasOrders(data) {
  return Boolean(data?.allOrders && Object.keys(data.allOrders).length);
}

export function isAuthPending(auth) {
  const { infoStatus, exitStatus, enterStatus } = auth;

  return infoStatus.loading || enterStatus.loading || exitStatus.loading;
}

export function isAuthHasErrors(auth) {
  const { enterStatus, exitStatus, infoStatus } = auth;

  return enterStatus.error || exitStatus.error || infoStatus.error;
}

export function isAuthResolved(auth) {
  const { enterStatus, exitStatus } = auth;
  return isAuthHasErrors(auth) || (enterStatus === false && exitStatus === false);
}

export function hasAuthData(auth) {
  return typeof auth.data !== 'undefined' && auth.data !== null;
}

export function isExiting(auth) {
  const { didExit, exitStatus } = auth;

  return !didExit && typeof exitStatus === 'object' && exitStatus.loading;
}

export function hasValidPhone(auth) {
  return auth && auth.data && auth.data.phone && isPhone(auth.data.phone);
}

export function hasVirtualCard(cards = []) {
  return cards.some((card) => card?.isVirtualCard);
}
